import { computed, ref, onMounted } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import ConversationApi from 'dashboard/api/inbox/conversation';
import presentation from './followup_ui.yaml';

export const menuConfig = ref(null);
export const menuCopy = computed(
  () => menuConfig.value?.copy || presentation.copy
);
let pendingMenu;

export const positiveId = value =>
  typeof value === 'string' &&
  /^[1-9][0-9]*$/.test(value) &&
  Number.isSafeInteger(Number(value))
    ? Number(value)
    : null;

export const loadFollowupMenu = () => {
  if (!pendingMenu) {
    pendingMenu = fetch('/copilot/chatwoot/api/followup/menu', {
      credentials: 'same-origin',
      cache: 'no-store',
      redirect: 'error',
      headers: { Accept: 'application/json' },
    })
      .then(async response => {
        if (!response.ok) throw new Error('followup_menu_unavailable');
        const config = await response.json();
        if (
          typeof config.enabled !== 'boolean' ||
          !Number.isSafeInteger(config.account_id) ||
          config.account_id <= 0 ||
          config.workspace_path !== '/copilot/chatwoot/followup' ||
          typeof config.copy?.title !== 'string'
        ) {
          throw new Error('followup_menu_invalid');
        }
        menuConfig.value = config;
        return config;
      })
      .finally(() => {
        pendingMenu = null;
      });
  }
  return pendingMenu;
};

export const useFollowupMenu = () => {
  const { accountId } = useAccount();
  onMounted(() => {
    loadFollowupMenu().catch(() => {
      menuConfig.value = null;
    });
  });
  return {
    menuConfig,
    menuAvailable: computed(
      () =>
        menuConfig.value?.enabled === true &&
        menuConfig.value.account_id === accountId.value
    ),
  };
};

export const resolveConversation = async (accountId, requestedId) => {
  let conversationId = requestedId;
  if (conversationId === null) {
    const response = await ConversationApi.get({
      status: 'all',
      assigneeType: 'all',
      page: 1,
      sortBy: 'last_activity_at_desc',
    });
    const candidate = response.data.data.payload[0];
    if (!candidate) return null;
    conversationId = positiveId(String(candidate.id));
  }
  if (conversationId === null) throw new Error('followup_context_invalid');
  const { data } = await ConversationApi.show(conversationId);
  if (data.id !== conversationId || data.account_id !== accountId) {
    throw new Error('followup_context_changed');
  }
  return conversationId;
};
